{
    "monster": {
        "key": "monster",
        "jobKey": "book/ooze",
        "position": {
            "x": 10,
            "y": 8,
            "z": 1
        }
    },
    "54Ft8": {
        "position": {
            "x": 9,
            "y": 8,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "54Ft8"
    },
    "ashe": {
        "position": {
            "x": 2,
            "y": 7,
            "z": 1
        },
        "templateKey": "player/book/ashe",
        "key": "ashe"
    },
    "V5jcW": {
        "position": {
            "x": 3,
            "y": 7,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "V5jcW"
    }
}
